import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import {
  type ResponseHeader,
  ResponseHeaderSchema,
} from '../responseHeader'
import {
  type SpaceGetApplicationsResponsePayload,
  SpaceGetApplicationsResponsePayloadSchema,
} from './spaceGetApplicationsResponsePayload'

export type SpaceGetApplicationsResponse = {
  header: ResponseHeader
  payload?: SpaceGetApplicationsResponsePayload
}

export const SpaceGetApplicationsResponseSchema: CborSchema<SpaceGetApplicationsResponse> =
  defineCborSchema<SpaceGetApplicationsResponse>({
    header: CborField({ key: 0, type: ResponseHeaderSchema }),
    payload: CborField({ key: 1, required: false, type: SpaceGetApplicationsResponsePayloadSchema }),
  })
